export default {"src":"/_next/static/media/view.32d79647.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};